import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as DataAccessEventsActions from './data-access-events.actions';
import * as DataAccessEventsSelectors from './data-access-events.selectors';

@Injectable()
export class DataAccessEventsFacade {
  event$ = this.store.pipe(select(DataAccessEventsSelectors.getEvent));
  filteredEventList$ = this.store.pipe(select(DataAccessEventsSelectors.getFilteredEventList));
  events$ = this.store.pipe(select(DataAccessEventsSelectors.getEvents));
  contributor$ = this.store.pipe(select(DataAccessEventsSelectors.getContributor));
  eventLoading$ = this.store.pipe(select(DataAccessEventsSelectors.getActiveEventLoadingState));
  eventError$ = this.store.pipe(select(DataAccessEventsSelectors.getActiveEventError));
  exhibitorEvents$ = this.store.pipe(select(DataAccessEventsSelectors.getExhibitorEvents));

  constructor(private readonly store: Store) {}

  pageOpened(eventUuid: string) {
    this.store.dispatch(DataAccessEventsActions.eventOpened({ eventUuid: eventUuid }));
  }

  contributorPageOpened(eventId: string, contactPersonIndex: string, fairId: string | undefined = undefined) {
    this.store.dispatch(
      DataAccessEventsActions.contributorPageOpened({
        eventUuid: eventId,
        contactPersonIndex: contactPersonIndex,
        fairId: fairId,
      })
    );
  }

  getEventById(eventId: string) {
    return this.store.pipe(select(DataAccessEventsSelectors.getEventById, { eventId }));
  }
}
